import { useEffect } from "react";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import AboutJoel from "@/components/site/AboutJoel";
import BookSection from "@/components/site/BookSection";
import SignupSection from "@/components/site/SignupSection";
import Footer from "@/components/site/Footer";
import { BRAND } from "@/lib/brand";

export default function Landing() {
  useEffect(() => {
    document.title = `${BRAND.bookTitle} — ${BRAND.name}`;
  }, []);
  return (
    <main data-testid="landing-page">
      <Header />
      <Hero />
      <AboutJoel />
      <BookSection />
      <SignupSection />
      <Footer />
    </main>
  );
}
